module.exports = __webpack_public_path__ + "static/media/CaretLeft.2a9edd82.svg";